module.exports = __webpack_public_path__ + "media/icons/tapicerka-welurowa-active-cd2c3116.png";